import { createSelector } from '@reduxjs/toolkit';

export const getSelfies = state => state.selfies && state.selfies.selfies;
export const getSelfiesLoading = state => Boolean(state.selfies && state.selfies.isLoading);
export const getSelfiesError = state => Boolean(state.selfies && state.selfies.error);
export const getSelfiesSaved = state => Boolean(state.selfies && state.selfies.saved);

export const getHasSelfies = createSelector(getSelfies, selfies => selfies.length > 0);
